module.exports = __webpack_public_path__ + "static/media/sector-data_top.ea75120e.jpg";